import * as actionTypes from '../actionTypes';
/**
 *
 * @param item
 * @param quantity
 * @param accept
 * @param reject
 * @param containerDefinitionKey
 */
export function itemPlanInventoryMappingCreate(itemDefinitionKey, quantity, itemPlanOriginDefinitionKey, containerDefinitionKey, accept, reject) {
    return {
        type: actionTypes.ITEM_PLAN_INVENTORY_MAPPING_CREATE,
        payload: {
            itemDefinitionKey,
            quantity,
            itemPlanOriginDefinitionKey,
            containerDefinitionKey,
        },
        meta: {
            accept,
            reject,
        },
    };
}
